export const optionId = o => o && typeof o === 'object' ? o.id : o;
export const optionLabel = o => o && typeof o === 'object' ? o.label : o;
export const emptyAnswer = v => v == null || typeof v === 'string' && !v.trim() || Array.isArray(v) && !v.length;
export function matches(v, expected, op = 'is') {
  if (emptyAnswer(v)) return false;
  const same = op.includes('contains') ? Array.isArray(v) && v.includes(expected) : v === expected;
  return ['is_not', 'not_contains'].includes(op) ? !same : same;
}
export const triggeredRules = (f,v) => (f.evidence_rules || []).filter(r => matches(v,r.value,f.type === 'checkbox' ? 'contains' : 'is'));
export function formRows(fields, values) {
  const rows = [], visible = {}; let section = null;
  const shown = (f, ctx, seen) => (f.show_when || []).every(r => seen[r.field_id] && matches(ctx[r.field_id], r.value, r.operator));
  for (let i=0; i<fields.length; i++) {
    const f=fields[i];
    if(f.type === 'section') {
      section=f; visible[f.id]=shown(f,values,visible);
      rows.push({field:f,value:values[f.id],path:f.id,visible:visible[f.id],evidence:{}});
      if(f.repeatable) {
        const children=[]; while(i+1<fields.length && fields[i+1].type!=='section') children.push(fields[++i]);
        (Array.isArray(values[f.id])?values[f.id]:[]).forEach((entry,index)=>{
          const seen={...visible},ctx={...values,...entry};
          children.forEach(child=>{seen[child.id]=visible[f.id] && shown(child,ctx,seen); rows.push({field:child,value:entry[child.id],evidence:entry.__evidence?.[child.id]||{},path:`${f.id}.${index}.${child.id}`,visible:seen[child.id],section:f.id,index});});
        });
      }
    } else {
      visible[f.id]=(!section || visible[section.id]) && shown(f,values,visible);
      rows.push({field:f,value:values[f.id],path:f.id,visible:visible[f.id],evidence:values.__evidence?.[f.id]||{}});
    }
  }
  return rows;
}
export function formErrors(fields,values) {
  const errors=[];
  for(const row of formRows(fields,values).filter(r=>r.visible)) {
    const {field:f,value:v,evidence:ev}=row; const add=message=>errors.push({path:row.path,label:f.label,message});
    if(f.type==='section') {if(f.repeatable && ((v?.length||0)<(f.min_entries||0) || (v?.length||0)>(f.max_entries||20))) add(`Add ${f.min_entries||0}–${f.max_entries||20} entries`);continue;}
    if(emptyAnswer(v)){if(f.required)add('Response required');continue;}
    if(['number','currency','quantity'].includes(f.type)) {
      const raw=f.type==='quantity'?v.quantity:v, n=Number(raw);
      if(emptyAnswer(raw)||!Number.isFinite(n))add('Enter a finite number');
      else if(f.minimum!=null && n<f.minimum)add(`Minimum ${f.minimum}`);
      else if(f.maximum!=null && n>f.maximum)add(`Maximum ${f.maximum}`);
      else if(f.precision!=null && Math.abs(n*10**f.precision-Math.round(n*10**f.precision))>1e-7)add(`Use at most ${f.precision} decimal places`);
      if(f.type==='quantity' && !f.units?.includes(v.unit))add('Choose a configured unit');
    }
    const rules=triggeredRules(f,v);
    if(rules.some(r=>r.comment)&&emptyAnswer(ev.comment))add('Comment required for this answer');
    if(rules.some(r=>r.photo)&&emptyAnswer(ev.photos))add('Photo required for this answer');
  }
  return errors;
}
export function focusFormError(errors) {
  if(!errors.length)return;
  const node=document.getElementById(`answer-${errors[0].path.replace(/\.__.*/, '')}`);
  node?.scrollIntoView({behavior:'smooth',block:'center'});
  (node?.querySelector('input,textarea,button,select')||node)?.focus();
}
export function formErrorMessage(e) {const d=e.response?.data?.detail; if(d?.errors)focusFormError(d.errors);return typeof d==='string'?d:d?.message||'Unable to save form';}
